const labels = {
  QrCode: {
    'Ref: Page title': 'Mijn bus',
    'Ref: Hi': 'Hallo',
    'Ref: Page content body':
      'Vergeet niet om bij aankomst en vertrek de QR -code van uw bus te scannen',
  },
};
export default labels;
